var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Helados "),_c('b',[_vm._v("Gelati")]),_vm._v(" App de Pedidos")])}]

export { render, staticRenderFns }